module.exports = __webpack_public_path__ + "static/media/phone.20d3d642.svg";